export default "__VITE_ASSET__C4olHRjk__"